import React from 'react';
import { Link } from 'react-router-dom';
import { FiShoppingCart } from 'react-icons/fi';
import { useCart } from '../../contexts/CartContext';

const FloatingActionButton = () => {
  const { getTotalItems } = useCart();
  const itemCount = getTotalItems();

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Link
        to="/cart"
        className="relative bg-black text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-shadow duration-200 block"
        aria-label="Open cart"
      >
        <FiShoppingCart size={24} />
        {itemCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-[#e4ac16] text-black text-xs rounded-full h-5 min-w-[20px] px-1 flex items-center justify-center font-semibold">
            {itemCount}
          </span>
        )}
      </Link>
    </div>
  );
};

export default FloatingActionButton;
